export async function getOrCreateEncryptionKey() {
    return null;
}
